import React, { useEffect } from 'react';
import { TravelBotChatSingleDialogGeneric } from './TravelBotChatSingleDialogGeneric';
var count = 0;
export var BlockingInputComponent = React.memo(function (props) {
    var setIsDisablingInputValue = props.setIsDisablingInputValue;
    var shouldBlockInput = count === 5;
    useEffect(function () {
        if (shouldBlockInput) {
            setIsDisablingInputValue(true);
            setTimeout(function () {
                setIsDisablingInputValue(false);
            }, 30 * 1000);
        }
        else {
            count++;
        }
    }, []);
    return shouldBlockInput ? (React.createElement(TravelBotChatSingleDialogGeneric, { message: {
            role: 'assistant',
            content: 'Sorry, service will be disabled for 30s.',
        }, livePersonAgentInitial: 'ag', livePersonAgentName: 'agent' })) : null;
});
//# sourceMappingURL=BlockingInputComponent.js.map